import { render, staticRenderFns } from "./UserLogins.vue?vue&type=template&id=25be98f5"
import script from "./UserLogins.vue?vue&type=script&lang=js"
export * from "./UserLogins.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports